import { Col, Container, Row, Stack } from "react-bootstrap";
import { renderSortIcon } from "../helperRenders";

export default function SongScoreTrendsHeader({ sortConfig, requestSort }) {
    return (
        <Container fluid className="sticky-top">
            <Row className="bg-ra-dark-blue text-white fw-bold py-1 rounded-2 fs-8-xs table-header user-select-none h-100">
                <Col xs onClick={() => requestSort("song.artist")} className=" align-content-center">
                    <Stack direction="horizontal">
                        <span>Artist</span>
                        <span className="col-1">{renderSortIcon("song.artist", sortConfig)}</span>
                    </Stack>
                </Col>
                <Col xs onClick={() => requestSort("song.title")} className=" align-content-center">
                    <Stack direction="horizontal">
                        <span>Title</span>
                        <span className="col-1">{renderSortIcon("song.title", sortConfig)}</span>
                    </Stack>
                </Col>
                <Col xs xl={1} onClick={requestSort ? () => requestSort("music_test_data.song_score_month") : null} className=" align-self-center">
                    <Stack direction="horizontal" className="justify-content-center">
                        <span className="offset-1 text-center">Month</span>
                        <span className="col-1">{renderSortIcon("music_test_data.song_score_month", sortConfig)}</span>
                    </Stack>
                </Col>
                <Col xs xl={1} onClick={requestSort ? () => requestSort("music_test_data.song_score") : null} className=" align-self-center">
                    <Stack direction="horizontal" className="justify-content-center">
                        <span className="offset-1 text-center">Week</span>
                        <span className="col-1">{renderSortIcon("music_test_data.song_score", sortConfig)}</span>
                    </Stack>
                </Col>
                <Col xs xl={1} onClick={requestSort ? () => requestSort("music_test_data.song_score_week_1") : null} className=" align-self-center">
                    <Stack direction="horizontal" className="justify-content-center">
                        <span className="offset-1 text-center text-nowrap">Week -1</span>
                        <span className="col-1">{renderSortIcon("music_test_data.song_score_week_1", sortConfig)}</span>
                    </Stack>
                </Col>
                <Col xs xl={1} onClick={requestSort ? () => requestSort("music_test_data.song_score_week_2") : null} className=" align-self-center">
                    <Stack direction="horizontal" className="justify-content-center">
                        <span className="offset-1 text-center text-nowrap">Week -2</span>
                        <span className="col-1">{renderSortIcon("music_test_data.song_score_week_2", sortConfig)}</span>
                    </Stack>
                </Col>
                <Col xs xl={1} onClick={requestSort ? () => requestSort("music_test_data.song_score_week_3") : null} className=" align-self-center">
                    <Stack direction="horizontal" className="justify-content-center">
                        <span className="offset-1 text-center text-nowrap">Week -3</span>
                        <span className="col-1">{renderSortIcon("music_test_data.song_score_week_3", sortConfig)}</span>
                    </Stack>
                </Col>
            </Row>
        </Container>
    );
}
